<template lang="pug">
  .select-color
    .contents(ref="colorlist")
      .contents-category(v-for="items in getColors")
        h4.contents-title(:class="contentsTitleCss(items)")
          //- 選択式サブカテゴリ
          span: img(:src="require(`@/assets/image/${items.parts}_title.svg`)")
          .selected-sub-category(v-if="isSp && items.sub_category")
            transition(name='highfade' apper)
              ul(v-if='isSelectedOpened')
                li(
                  v-for="(item, index) in items.sub_category"
                  :key="index"
                  @click='selectSubCategory(item.name); isSelectedOpened = !isSelectedOpened'
                ) {{ item.name }}
            p.selected-sub-category-current(
              v-for="(item, index) in items.sub_category"
              v-if='getSubCategory === item.name'
              :key="index"
              :class='{ opened: isSelectedOpened }'
              @click='isSelectedOpened = !isSelectedOpened'
            ) {{ item.name }}
        //- サブカテゴリが無い場合
        .contents-items(v-if="items.colors")
          ul.contents-list.scrollbar-hidden
            li.contents-list-row(v-for="(color, key) in items.colors" v-if="items.colors &&  !color.nonDisp")
              template(v-if="items.parts == 'unit'")
                span.item(:class="[color.code, { active: isCurrentUnit(color) }]" @click="setUnit(color)") {{ color.name }}
              template(v-if="items.parts == 'cabinet'")
                span.item(:class="[color.code, { active: isCurrentCabinet(color) }]" @click="setCabinet(color)") {{ color.name }}

        //- サブカテゴリがある場合
        .contents-sub(v-if="!isSp && items.sub_category" v-for="item in items.sub_category")
          h5.contents-sub-title {{ item.name }}
          .contents-items
            ul.contents-list
              li.contents-list-row(v-for="color in item.colors")
                span.item(:class="[color.code, { active: isCurrentSeat(color) }]" @click="setSeat({colors: color, category: item.name})") {{ color.name }}
        //- SP版のみ
        .contents-items(v-if="isSp && items.sub_category")
          ul.contents-list
            li.contents-list-row(v-for="color in selectedColor")
              span.item(:class="[color.code, { active: isCurrentSeat(color) }]" @click="setSeat({colors: color, category: getSubCategory})") {{ color.name }}
    transition(name='fade')
      p.scrolldown(v-if="!isSp && isScrollVisible")
        span.scrolldown-word Scroll
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { throttle } from 'lodash';
export default {
  name: 'SelectColor',
  mounted() {
    this.selectSubCategory();
    // scroll位置判定処理
    this.judgeScrollPosition();
  },
  computed: {
    ...mapGetters([
      'getColors',
      'isCurrentUnit',
      'isCurrentSeat',
      'isCurrentCabinet',
      'getCurrentModel',
      'getSubCategory',
      'isSp',
    ]),
  },
  data: () => ({
    isSelectedOpened: false,
    selectedColor: '',
    isScrollVisible: true,
  }),
  methods: {
    ...mapActions(['setUnit', 'setCabinet', 'setSeat', 'setSubCategory']),
    selectSubCategory(name = this.getSubCategory) {
      this.setSubCategory(name);
      this.selectedColor = this.getColors
        .find((element) => element.parts === 'seat')
        .sub_category.find(
          (element) => element.name == this.getSubCategory
        ).colors;
    },
    judgeScrollPosition() {
      const element = this.$refs.colorlist;
      element.onscroll = throttle(() => {
        const clientHeight = element.clientHeight;
        const scrollHeight = element.scrollHeight;
        // 一番下まで行ったか判定
        this.isScrollVisible =
          scrollHeight - (clientHeight + element.scrollTop + 100) > 1;
      }, 300);
    },
    contentsTitleCss(items) {
      if (items.parts.includes('unit')) return 'unit';
      if (items.parts === 'seat') return 'seat';
      if (items.parts === 'cabinet') return 'cabinet';
    },
  },
};
</script>

<style lang="scss" scoped>
.select-color {
  position: relative;
  width: 298px;
  height: 100%;
  padding-left: 27px;
  background: #fff;
}

.contents {
  flex: 1;
  width: calc(100% + 15px);
  height: calc(100% - 46px);
  margin-top: 46px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: left;

  &-category {
    + .contents-category {
      margin-top: 69px;
    }

    &:last-of-type {
      padding-bottom: 27px;
    }
  }

  &-title {
    span {
      display: block;

      img {
        width: 100%;
      }
    }

    &.unit {
      span {
        width: 48px;
      }
    }

    &.seat {
      span {
        width: 47px;
      }
    }

    &.cabinet {
      span {
        width: 82px;
      }
    }
  }

  &-sub {
    + .contents-sub {
      margin-top: 24px;
    }
  }

  &-sub-title {
    margin-top: 20px;
    font-size: 15px;
    font-weight: bold;
  }

  &-items {
    margin-top: 18px;
  }

  &-list {
    &-row {
      position: relative;
      display: flex;
      align-items: center;
      height: 18px;
      padding-left: 27px;
      margin-top: 12px;
      font-size: 12px;
      font-weight: 500;
      color: #9a9a9a;

      &:first-of-type {
        margin-top: 0;
      }

      .item {
        cursor: pointer;
        transition: color 250ms ease-out;

        &::before {
          position: absolute;
          top: 50%;
          left: 2px;
          width: 16px;
          height: 16px;
          margin-top: -8px;
          content: '';
          border-radius: 50%;
          transition: transform 250ms ease-out;
          transform: scale(1);
        }

        &.active {
          color: #000;

          &::before {
            transform: scale(1.2);
          }
        }

        &.color-code-white,
        &.color-code-vanillawhite,
        &.color-code-icyblue {
          &::before {
            border: 1px solid #9a9a9a;
          }
        }
        @include pc-layout {
          &:hover {
            color: #000;

            &::before {
              transform: scale(1.2);
            }
          }
        }
      }
    }
  }
}

.selected-sub-category {
  position: relative;
  margin-left: vw(40);

  ul {
    position: absolute;
    bottom: calc(100% + #{vw(10)});
    left: 0;
    width: vw(530);
    background: #fff;
    border: 1px solid #efefef;

    li {
      display: flex;
      align-items: center;
      height: vw(54);
      padding: 0 vw(16);
      font-size: vw(30);
      border-bottom: 1px solid #efefef;

      &:last-of-type {
        border-bottom: none;
      }
    }
  }

  &-current {
    position: relative;
    padding-right: vw(30);
    font-size: vw(30);

    &::before {
      position: absolute;
      top: 50%;
      right: 0;
      display: block;
      content: '';
      border: vw(8) solid transparent;
      border-top: vw(20) solid #000;
      transition: transform 250ms ease-in-out;
      transform: translateY(-30%) rotateZ(0);
    }

    &.opened {
      &::before {
        transform: translateY(-60%) rotateZ(-180deg);
      }
    }
  }
}

.scrolldown {
  position: absolute;
  right: 28px;
  bottom: 33px;
  width: 17px;
  height: 56px;
  border-left: solid 1px #000;
  animation: arrowmove 2s ease-in-out infinite;

  &::before {
    position: absolute;
    bottom: 0;
    left: 4px;
    width: 1px;
    height: 10px;
    content: '';
    background: #000;
    transform: skewX(-45deg);
  }

  &-word {
    padding-top: 4px;
    padding-left: 4px;
    font-size: 0.7rem;
    color: #000;
    letter-spacing: 0.05em;
    writing-mode: vertical-rl;
  }
}

.scrollbar-hidden {
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.color-code-blackmetallic::before {
  border: 1px solid #555554;
}

@include sp-layout {
  .select-color {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: vw(430);
    padding-left: 0;
  }

  .contents {
    width: 100%;
    height: 100%;
    padding: vw(24) 0 0 vw(40);
    margin: 0;

    &-category {
      margin: 0;

      + .contents-category {
        margin-top: vw(20);

        .selected-sub-category {
          display: flex;
          align-items: center;
        }
      }

      &:last-of-type {
        padding-bottom: 0;
      }
    }

    &-title {
      display: flex;

      &.unit {
        span {
          width: vw(96);
        }
      }

      &.seat {
        span {
          width: vw(94);
        }
      }

      &.cabinet {
        span {
          width: vw(174);
        }
      }
    }

    &-items {
      margin-top: vw(8);
      margin-left: vw(-10);
      overflow-x: scroll;
    }

    &-list {
      display: inline-flex;
      padding: vw(10) vw(80) vw(10) vw(10);

      &-row {
        width: vw(60);
        height: vw(60);
        padding-left: 0;
        margin-top: 0;
        margin-left: vw(36);
        text-indent: -99999px;

        &:first-of-type {
          margin-left: 0;
        }

        .item {
          &::before {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>
